export const sortLowToHigh = (array: any, sortString: string) => {
  return array.sort((a: any, b: any) => a[sortString] - b[sortString]);
};
